import {
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import {
  lobsFeatureKey,
  LobState,
} from '../../reducer/lob/lob.reducer';

export const selectLobState = createFeatureSelector<LobState>(lobsFeatureKey);

export const selectLobs = createSelector(selectLobState, (state: LobState) => state.lobs);
